export interface PlayerError {
  readonly errorCode: string;
  readonly errorMessage: string;
}
